import NumberVisualization from "views/components/visualizations/number/NumberVisualization";
import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Series from "views/logic/aggregationbuilder/Series";
import SeriesConfig from "views/logic/aggregationbuilder/SeriesConfig";
import { addWidget } from "views/logic/slices/widgetActions";
export const CreateMessageCount = () => {
  const series = Series.forFunction("count()").toBuilder().config(new SeriesConfig("Message Count")).build();
  return AggregationWidget.builder().newId().config(AggregationWidgetConfig.builder().series([series]).visualization(NumberVisualization.type).build()).build();
};
const AddMessageCountActionHandler = () => (dispatch) => dispatch(addWidget(CreateMessageCount()));
export default AddMessageCountActionHandler;
